import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCalculator } from '../context/CalculatorContext';

// Componente que protege rutas verificando si el usuario aceptó la política
const ProtectedRoute = ({ children }) => {
  const { hasAcceptedPolicy } = useCalculator();

  // Si no ha aceptado la política, redirigir al Home
  if (!hasAcceptedPolicy) {
    console.log('🚫 Acceso denegado: Política no aceptada. Redirigiendo a Home...');
    return <Navigate to="/" replace />;
  }

  // Si aceptó la política, mostrar el componente
  return children;
};

export default ProtectedRoute;